<app-header></app-header>

<div class="container-xxl">
  <section class="banner d-flex justify-content-center align-items-center text-center">
    <div class="content"  data-aos="zoom-in" data-aos-duration="2000">
      <div class="title">
        <span>التقييمات</span>
      </div>
    
      <div class="links">
        <a class="text-decoration-none" href="/home"> الرئيسية </a>
        <span>/ تقييمات المعلم </span>
      </div>
    </div>
  </section>
  
  <main>
      <div class="container">
        
        <div class="row d-flex justify-content-around">
          <div class="feedback col-md-5"  data-aos="fade-left" data-aos-duration="2000">
            <b>لقد انهيت التعليم فى هذه المجموعة نطلب منك تقييم طلابك في المجموعة</b>
            <hr>
            <div>
              <div class="row">
                <div class="col-md-4">
                  <label>اسم الدورة التدريبية</label>
                </div>
                <div class="col-md-6">
                  <b>{{courseTitle}}</b> 
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <label>اسم المجموعة</label>
                </div>
                <div class="col-md-6">
                  <p>{{ class.Number }}</p>
                </div>
              </div>
            </div>
          </div>
         
          <form class="col-md-5" [formGroup]="addForm"  *ngIf="!studentsEnded" enctype="multipart/form-data"  data-aos="fade-right" data-aos-duration="2000">          
              <div class="form-group">
           
                <label>رأيك فى أداء الطالب</label><br>
                <b style="text-align: center;">{{currentStudentName}}</b><br>
                <input
                  formControlName="message"
                  [class.is-invalid]="message.invalid && message.touched"
                  type="text"
                  class="form-control"
                />
                <div *ngIf="message.errors && message.invalid && message.touched">
                  <small class="text-danger" *ngIf="message.errors?.required">
                    الرأى مطلوب
                  </small>
                  <small class="text-danger" *ngIf="Title.errors.minlength">
                    اقل عدد احرف مسموح بها 3 احروف
                  </small>
                  <small *ngIf="Title.errors?.forbiddenName">
                    {{ Title.errors?.forbiddenName.value }} غير مسموح به
                  </small>
                </div>
              </div>
        
             <!--  <div class="form-group">
                <label>التقييم</label>
                <input
                  formControlName="starsNumber"
                  [class.is-invalid]="starsNumber.invalid && starsNumber.touched"
                  type="text"
                  class="form-control"
                />
                <div
                  *ngIf="
                    starsNumber.errors && starsNumber.invalid && starsNumber.touched
                  "
                >
                  <small class="text-danger" *ngIf="starsNumber.errors?.required">
                    التقييم مطلوب
                  </small>
                </div>
              </div>
         -->
    
    
         <div class="form-group">
          <label>التقييم</label> &nbsp;
    
          <input type="radio" name="stars"(change)="checkChanged(1,$event.target.checked)"value="1" > 1 &nbsp;
          <input type="radio" name="stars"(change)="checkChanged(2,$event.target.checked)" value="2"> 2 &nbsp;
          <input type="radio" name="stars"(change)="checkChanged(3,$event.target.checked)" value="3"> 3 &nbsp;
          <input type="radio" name="stars"(change)="checkChanged(4,$event.target.checked)"  value="4"> 4 &nbsp;
          <input type="radio" name="stars" (change)="checkChanged(5,$event.target.checked)"  value="5"> 5 &nbsp;
           
    
        </div>
              <input
                type="submit"
                class="submit add btn btn-primary"
                value="إضافة"
                (click)="submit()"
                [disabled]="!addForm.valid"
              />                            
          </form>
        </div>
        <p  data-aos="zoom-in" data-aos-duration="2000" *ngIf="studentsEnded"><br> لقد أنهيت تقييم جميع طلبة الفصل شكرا لك </p>
      </div>
    </main>
</div>
  <app-footer></app-footer>